// This component mimicks react-motion-ui-pack!
// We'd like to use that package, but as of 2018/02/07, it hasn't been updated
//  for React 16.

import mapValues from 'lodash/mapValues'
import PropTypes from 'prop-types'
import React, {Children, cloneElement} from 'react'
import {spring, TransitionMotion} from 'react-motion'

import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion'

import CustomPropTypes from '../../customPropTypes'

export const combineOnKey = (key, state, newState) => ({[key]: {...state[key], ...newState}})

const getStyles = (children, style, fn) =>
  children
    ? Children.map(children, (child) => ({
        key: child.key,
        data: child,
        style: fn ? mapValues(style, fn) : style,
      }))
    : []

const renderItem = ({data: child, style}) =>
  cloneElement(child, combineOnKey('style', child.props, style))

const Transition = ({children, enter, leave}) => {
  const prefersReducedMotion = usePrefersReducedMotion()

  return (
    <TransitionMotion
      defaultStyles={getStyles(children, leave)}
      styles={getStyles(children, enter, prefersReducedMotion ? undefined : spring)}
      willEnter={() => leave}
      willLeave={() => mapValues(leave, prefersReducedMotion ? undefined : spring)}
    >
      {(items) => <div>{items.map(renderItem)}</div>}
    </TransitionMotion>
  )
}

Transition.propTypes = {
  children: CustomPropTypes.children,
  enter: PropTypes.shape({}),
  leave: PropTypes.shape({}),
}

export default Transition
